var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmotion(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Emotion"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M31.25 24.5703C31.8906 24.5703 32.4219 25.1016 32.4219 25.7422C32.4219 26.3828 31.8906 26.9141 31.25 26.9141C30.6094 26.9141 30.0781 26.3828 30.0781 25.7422C30.0781 25.1016 30.6094 24.5703 31.25 24.5703Z",
    fill: "#898989"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M14.0625 24.5703C14.7031 24.5703 15.2344 25.1016 15.2344 25.7422C15.2344 26.3828 14.7031 26.9141 14.0625 26.9141C13.4219 26.9141 12.8906 26.3828 12.8906 25.7422C12.8906 25.1016 13.4219 24.5703 14.0625 24.5703Z",
    fill: "#898989"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M34.375 10.9375C32.6516 10.9375 31.25 9.53594 31.25 7.8125V4.6875C31.25 2.96406 32.6516 1.5625 34.375 1.5625C36.0984 1.5625 37.5 2.96406 37.5 4.6875V7.03125C37.5 7.4625 37.15 7.8125 36.7188 7.8125C36.2875 7.8125 35.9375 7.4625 35.9375 7.03125V4.6875C35.9375 3.825 35.2375 3.125 34.375 3.125C33.5125 3.125 32.8125 3.825 32.8125 4.6875V7.8125C32.8125 8.675 33.5125 9.375 34.375 9.375C34.8063 9.375 35.1562 9.725 35.1562 10.1562C35.1562 10.5875 34.8063 10.9375 34.375 10.9375Z",
    fill: "#898989"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M12.5 10.9375C10.7766 10.9375 9.375 9.53594 9.375 7.8125V4.6875C9.375 2.96406 10.7766 1.5625 12.5 1.5625C14.2234 1.5625 15.625 2.96406 15.625 4.6875V7.03125C15.625 7.4625 15.275 7.8125 14.8438 7.8125C14.4125 7.8125 14.0625 7.4625 14.0625 7.03125V4.6875C14.0625 3.825 13.3625 3.125 12.5 3.125C11.6375 3.125 10.9375 3.825 10.9375 4.6875V7.8125C10.9375 8.675 11.6375 9.375 12.5 9.375C12.9313 9.375 13.2812 9.725 13.2812 10.1562C13.2812 10.5875 12.9313 10.9375 12.5 10.9375Z",
    fill: "#898989"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_13"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M46.0938 45.2734C45.6625 45.2734 45.3125 44.9234 45.3125 44.4922V8.59375C45.3125 8.16406 44.9609 7.8125 44.5312 7.8125H37.5C37.0688 7.8125 36.7188 7.4625 36.7188 7.03125C36.7188 6.6 37.0688 6.25 37.5 6.25H44.5312C45.8234 6.25 46.875 7.30156 46.875 8.59375V44.4922C46.875 44.9234 46.525 45.2734 46.0938 45.2734Z",
    fill: "#898989"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_16"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_17"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_18"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M32.0312 7.8125H13.2812C12.85 7.8125 12.5 7.4625 12.5 7.03125C12.5 6.6 12.85 6.25 13.2812 6.25H32.0312C32.4625 6.25 32.8125 6.6 32.8125 7.03125C32.8125 7.4625 32.4625 7.8125 32.0312 7.8125Z",
    fill: "#898989"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_19"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M41.4062 46.875H5.46875C4.17656 46.875 3.125 45.8234 3.125 44.5312V14.8438C3.125 14.4125 3.475 14.0625 3.90625 14.0625C4.3375 14.0625 4.6875 14.4125 4.6875 14.8438V44.5312C4.6875 44.9609 5.03906 45.3125 5.46875 45.3125H41.4062C41.8359 45.3125 42.1875 44.9609 42.1875 44.5312V8.59375C42.1875 8.16406 41.8359 7.8125 41.4062 7.8125H35.1562C34.725 7.8125 34.375 7.4625 34.375 7.03125C34.375 6.6 34.725 6.25 35.1562 6.25H41.4062C42.6984 6.25 43.75 7.30156 43.75 8.59375V44.5312C43.75 45.8234 42.6984 46.875 41.4062 46.875Z",
    fill: "#898989"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_21"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_22"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M39.8453 15.625H3.90625C3.475 15.625 3.125 15.275 3.125 14.8438V8.59375C3.125 7.30156 4.17656 6.25 5.46875 6.25H10.1562C10.5875 6.25 10.9375 6.6 10.9375 7.03125C10.9375 7.4625 10.5875 7.8125 10.1562 7.8125H5.46875C5.03906 7.8125 4.6875 8.16406 4.6875 8.59375V14.0625H39.8453C40.2766 14.0625 40.6266 14.4125 40.6266 14.8438C40.6266 15.275 40.2766 15.625 39.8453 15.625Z",
    fill: "#898989"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_23"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_24"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M25 31.2109C24.5687 31.2109 24.2188 30.8609 24.2188 30.4297C24.2188 29.5672 23.5187 28.8672 22.6562 28.8672C21.7938 28.8672 21.0938 29.5672 21.0938 30.4297C21.0938 30.8609 20.7437 31.2109 20.3125 31.2109C19.8813 31.2109 19.5312 30.8609 19.5312 30.4297C19.5312 28.7062 20.9328 27.3047 22.6562 27.3047C24.3797 27.3047 25.7812 28.7062 25.7812 30.4297C25.7812 30.8609 25.4313 31.2109 25 31.2109Z",
    fill: "#898989"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_26"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_27"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_28"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M31.25 27.6953C30.1734 27.6953 29.2969 26.8187 29.2969 25.7422C29.2969 24.6656 30.1734 23.7891 31.25 23.7891C32.3266 23.7891 33.2031 24.6656 33.2031 25.7422C33.2031 26.8187 32.3266 27.6953 31.25 27.6953ZM31.25 25.3516C31.0422 25.3516 30.8594 25.5344 30.8594 25.7422C30.8594 25.95 31.0422 26.1328 31.25 26.1328C31.4578 26.1328 31.6406 25.95 31.6406 25.7422C31.6406 25.5344 31.4578 25.3516 31.25 25.3516Z",
    fill: "#898989"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_29"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_30"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M14.0625 27.6953C12.9859 27.6953 12.1094 26.8187 12.1094 25.7422C12.1094 24.6656 12.9859 23.7891 14.0625 23.7891C15.1391 23.7891 16.0156 24.6656 16.0156 25.7422C16.0156 26.8187 15.1391 27.6953 14.0625 27.6953ZM14.0625 25.3516C13.8547 25.3516 13.6719 25.5344 13.6719 25.7422C13.6719 25.95 13.8547 26.1328 14.0625 26.1328C14.2703 26.1328 14.4531 25.95 14.4531 25.7422C14.4531 25.5344 14.2703 25.3516 14.0625 25.3516Z",
    fill: "#898989"
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmotion);
export default __webpack_public_path__ + "static/media/emotion.6c6ed57200e2a81cc5d078c49029f0df.svg";
export { ForwardRef as ReactComponent };